// ==============================|| OVERRIDES - TABS ||============================== //

import { Theme } from "@mui/material"

export default function Tabs() {
    return {
        MuiTabs: {
            styleOverrides: {
                vertical: {
                    overflow: "visible",
                },
                root: ({ theme }: { theme: Theme }) => ({
                    backgroundColor: theme.palette.grey[50],
                }),
            },
        },
    }
}
